export var HeroIcons;
(function (HeroIcons) {
    HeroIcons["AcademicCapIcon"] = "AcademicCapIcon";
    HeroIcons["AdjustmentsIcon"] = "AdjustmentsIcon";
    HeroIcons["AnnotationIcon"] = "AnnotationIcon";
    HeroIcons["ArchiveIcon"] = "ArchiveIcon";
    HeroIcons["ArrowCircleDownIcon"] = "ArrowCircleDownIcon";
    HeroIcons["ArrowCircleLeftIcon"] = "ArrowCircleLeftIcon";
    HeroIcons["ArrowCircleRightIcon"] = "ArrowCircleRightIcon";
    HeroIcons["ArrowCircleUpIcon"] = "ArrowCircleUpIcon";
    HeroIcons["ArrowDownIcon"] = "ArrowDownIcon";
    HeroIcons["ArrowLeftIcon"] = "ArrowLeftIcon";
    HeroIcons["ArrowNarrowDownIcon"] = "ArrowNarrowDownIcon";
    HeroIcons["ArrowNarrowLeftIcon"] = "ArrowNarrowLeftIcon";
    HeroIcons["ArrowNarrowRightIcon"] = "ArrowNarrowRightIcon";
    HeroIcons["ArrowNarrowUpIcon"] = "ArrowNarrowUpIcon";
    HeroIcons["ArrowRightIcon"] = "ArrowRightIcon";
    HeroIcons["ArrowUpIcon"] = "ArrowUpIcon";
    HeroIcons["ArrowsExpandIcon"] = "ArrowsExpandIcon";
    HeroIcons["AtSymbolIcon"] = "AtSymbolIcon";
    HeroIcons["BackspaceIcon"] = "BackspaceIcon";
    HeroIcons["BadgeCheckIcon"] = "BadgeCheckIcon";
    HeroIcons["BanIcon"] = "BanIcon";
    HeroIcons["BeakerIcon"] = "BeakerIcon";
    HeroIcons["BellIcon"] = "BellIcon";
    HeroIcons["BookOpenIcon"] = "BookOpenIcon";
    HeroIcons["BookmarkAltIcon"] = "BookmarkAltIcon";
    HeroIcons["BookmarkIcon"] = "BookmarkIcon";
    HeroIcons["BriefcaseIcon"] = "BriefcaseIcon";
    HeroIcons["CakeIcon"] = "CakeIcon";
    HeroIcons["CalculatorIcon"] = "CalculatorIcon";
    HeroIcons["CalendarIcon"] = "CalendarIcon";
    HeroIcons["CameraIcon"] = "CameraIcon";
    HeroIcons["CashIcon"] = "CashIcon";
    HeroIcons["ChartBarIcon"] = "ChartBarIcon";
    HeroIcons["ChartPieIcon"] = "ChartPieIcon";
    HeroIcons["ChartSquareBarIcon"] = "ChartSquareBarIcon";
    HeroIcons["ChatAlt2Icon"] = "ChatAlt2Icon";
    HeroIcons["ChatAltIcon"] = "ChatAltIcon";
    HeroIcons["ChatIcon"] = "ChatIcon";
    HeroIcons["CheckCircleIcon"] = "CheckCircleIcon";
    HeroIcons["CheckIcon"] = "CheckIcon";
    HeroIcons["ChevronDoubleDownIcon"] = "ChevronDoubleDownIcon";
    HeroIcons["ChevronDoubleLeftIcon"] = "ChevronDoubleLeftIcon";
    HeroIcons["ChevronDoubleRightIcon"] = "ChevronDoubleRightIcon";
    HeroIcons["ChevronDoubleUpIcon"] = "ChevronDoubleUpIcon";
    HeroIcons["ChevronDownIcon"] = "ChevronDownIcon";
    HeroIcons["ChevronLeftIcon"] = "ChevronLeftIcon";
    HeroIcons["ChevronRightIcon"] = "ChevronRightIcon";
    HeroIcons["ChevronUpIcon"] = "ChevronUpIcon";
    HeroIcons["ChipIcon"] = "ChipIcon";
    HeroIcons["ClipboardCheckIcon"] = "ClipboardCheckIcon";
    HeroIcons["ClipboardCopyIcon"] = "ClipboardCopyIcon";
    HeroIcons["ClipboardIcon"] = "ClipboardIcon";
    HeroIcons["ClipboardListIcon"] = "ClipboardListIcon";
    HeroIcons["ClockIcon"] = "ClockIcon";
    HeroIcons["CloudDownloadIcon"] = "CloudDownloadIcon";
    HeroIcons["CloudIcon"] = "CloudIcon";
    HeroIcons["CloudUploadIcon"] = "CloudUploadIcon";
    HeroIcons["CodeIcon"] = "CodeIcon";
    HeroIcons["CogIcon"] = "CogIcon";
    HeroIcons["CollectionIcon"] = "CollectionIcon";
    HeroIcons["ColorSwatchIcon"] = "ColorSwatchIcon";
    HeroIcons["CreditCardIcon"] = "CreditCardIcon";
    HeroIcons["CubeIcon"] = "CubeIcon";
    HeroIcons["CubeTransparentIcon"] = "CubeTransparentIcon";
    HeroIcons["CurrencyBangladeshiIcon"] = "CurrencyBangladeshiIcon";
    HeroIcons["CurrencyDollarIcon"] = "CurrencyDollarIcon";
    HeroIcons["CurrencyEuroIcon"] = "CurrencyEuroIcon";
    HeroIcons["CurrencyPoundIcon"] = "CurrencyPoundIcon";
    HeroIcons["CurrencyRupeeIcon"] = "CurrencyRupeeIcon";
    HeroIcons["CurrencyYenIcon"] = "CurrencyYenIcon";
    HeroIcons["CursorClickIcon"] = "CursorClickIcon";
    HeroIcons["DatabaseIcon"] = "DatabaseIcon";
    HeroIcons["DesktopComputerIcon"] = "DesktopComputerIcon";
    HeroIcons["DeviceMobileIcon"] = "DeviceMobileIcon";
    HeroIcons["DeviceTabletIcon"] = "DeviceTabletIcon";
    HeroIcons["DocumentAddIcon"] = "DocumentAddIcon";
    HeroIcons["DocumentDownloadIcon"] = "DocumentDownloadIcon";
    HeroIcons["DocumentDuplicateIcon"] = "DocumentDuplicateIcon";
    HeroIcons["DocumentIcon"] = "DocumentIcon";
    HeroIcons["DocumentRemoveIcon"] = "DocumentRemoveIcon";
    HeroIcons["DocumentReportIcon"] = "DocumentReportIcon";
    HeroIcons["DocumentSearchIcon"] = "DocumentSearchIcon";
    HeroIcons["DocumentTextIcon"] = "DocumentTextIcon";
    HeroIcons["DotsCircleHorizontalIcon"] = "DotsCircleHorizontalIcon";
    HeroIcons["DotsHorizontalIcon"] = "DotsHorizontalIcon";
    HeroIcons["DotsVerticalIcon"] = "DotsVerticalIcon";
    HeroIcons["DownloadIcon"] = "DownloadIcon";
    HeroIcons["DuplicateIcon"] = "DuplicateIcon";
    HeroIcons["EmojiHappyIcon"] = "EmojiHappyIcon";
    HeroIcons["EmojiSadIcon"] = "EmojiSadIcon";
    HeroIcons["ExclamationCircleIcon"] = "ExclamationCircleIcon";
    HeroIcons["ExclamationIcon"] = "ExclamationIcon";
    HeroIcons["ExternalLinkIcon"] = "ExternalLinkIcon";
    HeroIcons["EyeIcon"] = "EyeIcon";
    HeroIcons["EyeOffIcon"] = "EyeOffIcon";
    HeroIcons["FastForwardIcon"] = "FastForwardIcon";
    HeroIcons["FilmIcon"] = "FilmIcon";
    HeroIcons["FilterIcon"] = "FilterIcon";
    HeroIcons["FingerPrintIcon"] = "FingerPrintIcon";
    HeroIcons["FireIcon"] = "FireIcon";
    HeroIcons["FlagIcon"] = "FlagIcon";
    HeroIcons["FolderAddIcon"] = "FolderAddIcon";
    HeroIcons["FolderDownloadIcon"] = "FolderDownloadIcon";
    HeroIcons["FolderIcon"] = "FolderIcon";
    HeroIcons["FolderOpenIcon"] = "FolderOpenIcon";
    HeroIcons["FolderRemoveIcon"] = "FolderRemoveIcon";
    HeroIcons["GiftIcon"] = "GiftIcon";
    HeroIcons["GlobeAltIcon"] = "GlobeAltIcon";
    HeroIcons["GlobeIcon"] = "GlobeIcon";
    HeroIcons["HandIcon"] = "HandIcon";
    HeroIcons["HashtagIcon"] = "HashtagIcon";
    HeroIcons["HeartIcon"] = "HeartIcon";
    HeroIcons["HomeIcon"] = "HomeIcon";
    HeroIcons["IdentificationIcon"] = "IdentificationIcon";
    HeroIcons["InboxIcon"] = "InboxIcon";
    HeroIcons["InboxInIcon"] = "InboxInIcon";
    HeroIcons["InformationCircleIcon"] = "InformationCircleIcon";
    HeroIcons["KeyIcon"] = "KeyIcon";
    HeroIcons["LibraryIcon"] = "LibraryIcon";
    HeroIcons["LightBulbIcon"] = "LightBulbIcon";
    HeroIcons["LightningBoltIcon"] = "LightningBoltIcon";
    HeroIcons["LinkIcon"] = "LinkIcon";
    HeroIcons["LocationMarkerIcon"] = "LocationMarkerIcon";
    HeroIcons["LockClosedIcon"] = "LockClosedIcon";
    HeroIcons["LockOpenIcon"] = "LockOpenIcon";
    HeroIcons["LoginIcon"] = "LoginIcon";
    HeroIcons["LogoutIcon"] = "LogoutIcon";
    HeroIcons["MailIcon"] = "MailIcon";
    HeroIcons["MailOpenIcon"] = "MailOpenIcon";
    HeroIcons["MapIcon"] = "MapIcon";
    HeroIcons["MenuAlt1Icon"] = "MenuAlt1Icon";
    HeroIcons["MenuAlt2Icon"] = "MenuAlt2Icon";
    HeroIcons["MenuAlt3Icon"] = "MenuAlt3Icon";
    HeroIcons["MenuAlt4Icon"] = "MenuAlt4Icon";
    HeroIcons["MenuIcon"] = "MenuIcon";
    HeroIcons["MicrophoneIcon"] = "MicrophoneIcon";
    HeroIcons["MinusCircleIcon"] = "MinusCircleIcon";
    HeroIcons["MinusIcon"] = "MinusIcon";
    HeroIcons["MinusSmIcon"] = "MinusSmIcon";
    HeroIcons["MoonIcon"] = "MoonIcon";
    HeroIcons["MusicNoteIcon"] = "MusicNoteIcon";
    HeroIcons["NewspaperIcon"] = "NewspaperIcon";
    HeroIcons["OfficeBuildingIcon"] = "OfficeBuildingIcon";
    HeroIcons["PaperAirplaneIcon"] = "PaperAirplaneIcon";
    HeroIcons["PaperClipIcon"] = "PaperClipIcon";
    HeroIcons["PauseIcon"] = "PauseIcon";
    HeroIcons["PencilAltIcon"] = "PencilAltIcon";
    HeroIcons["PencilIcon"] = "PencilIcon";
    HeroIcons["PhoneIcon"] = "PhoneIcon";
    HeroIcons["PhoneIncomingIcon"] = "PhoneIncomingIcon";
    HeroIcons["PhoneMissedCallIcon"] = "PhoneMissedCallIcon";
    HeroIcons["PhoneOutgoingIcon"] = "PhoneOutgoingIcon";
    HeroIcons["PhotographIcon"] = "PhotographIcon";
    HeroIcons["PlayIcon"] = "PlayIcon";
    HeroIcons["PlusCircleIcon"] = "PlusCircleIcon";
    HeroIcons["PlusIcon"] = "PlusIcon";
    HeroIcons["PlusSmIcon"] = "PlusSmIcon";
    HeroIcons["PresentationChartBarIcon"] = "PresentationChartBarIcon";
    HeroIcons["PresentationChartLineIcon"] = "PresentationChartLineIcon";
    HeroIcons["PrinterIcon"] = "PrinterIcon";
    HeroIcons["PuzzleIcon"] = "PuzzleIcon";
    HeroIcons["QrcodeIcon"] = "QrcodeIcon";
    HeroIcons["QuestionMarkCircleIcon"] = "QuestionMarkCircleIcon";
    HeroIcons["ReceiptRefundIcon"] = "ReceiptRefundIcon";
    HeroIcons["ReceiptTaxIcon"] = "ReceiptTaxIcon";
    HeroIcons["RefreshIcon"] = "RefreshIcon";
    HeroIcons["ReplyIcon"] = "ReplyIcon";
    HeroIcons["RewindIcon"] = "RewindIcon";
    HeroIcons["RssIcon"] = "RssIcon";
    HeroIcons["SaveAsIcon"] = "SaveAsIcon";
    HeroIcons["SaveIcon"] = "SaveIcon";
    HeroIcons["ScaleIcon"] = "ScaleIcon";
    HeroIcons["ScissorsIcon"] = "ScissorsIcon";
    HeroIcons["SearchCircleIcon"] = "SearchCircleIcon";
    HeroIcons["SearchIcon"] = "SearchIcon";
    HeroIcons["SelectorIcon"] = "SelectorIcon";
    HeroIcons["ServerIcon"] = "ServerIcon";
    HeroIcons["ShareIcon"] = "ShareIcon";
    HeroIcons["ShieldCheckIcon"] = "ShieldCheckIcon";
    HeroIcons["ShieldExclamationIcon"] = "ShieldExclamationIcon";
    HeroIcons["ShoppingBagIcon"] = "ShoppingBagIcon";
    HeroIcons["ShoppingCartIcon"] = "ShoppingCartIcon";
    HeroIcons["SortAscendingIcon"] = "SortAscendingIcon";
    HeroIcons["SortDescendingIcon"] = "SortDescendingIcon";
    HeroIcons["SparklesIcon"] = "SparklesIcon";
    HeroIcons["SpeakerphoneIcon"] = "SpeakerphoneIcon";
    HeroIcons["StarIcon"] = "StarIcon";
    HeroIcons["StatusOfflineIcon"] = "StatusOfflineIcon";
    HeroIcons["StatusOnlineIcon"] = "StatusOnlineIcon";
    HeroIcons["StopIcon"] = "StopIcon";
    HeroIcons["SunIcon"] = "SunIcon";
    HeroIcons["SupportIcon"] = "SupportIcon";
    HeroIcons["SwitchHorizontalIcon"] = "SwitchHorizontalIcon";
    HeroIcons["SwitchVerticalIcon"] = "SwitchVerticalIcon";
    HeroIcons["TableIcon"] = "TableIcon";
    HeroIcons["TagIcon"] = "TagIcon";
    HeroIcons["TemplateIcon"] = "TemplateIcon";
    HeroIcons["TerminalIcon"] = "TerminalIcon";
    HeroIcons["ThumbDownIcon"] = "ThumbDownIcon";
    HeroIcons["ThumbUpIcon"] = "ThumbUpIcon";
    HeroIcons["TicketIcon"] = "TicketIcon";
    HeroIcons["TranslateIcon"] = "TranslateIcon";
    HeroIcons["TrashIcon"] = "TrashIcon";
    HeroIcons["TrendingDownIcon"] = "TrendingDownIcon";
    HeroIcons["TrendingUpIcon"] = "TrendingUpIcon";
    HeroIcons["TruckIcon"] = "TruckIcon";
    HeroIcons["UploadIcon"] = "UploadIcon";
    HeroIcons["UserAddIcon"] = "UserAddIcon";
    HeroIcons["UserCircleIcon"] = "UserCircleIcon";
    HeroIcons["UserGroupIcon"] = "UserGroupIcon";
    HeroIcons["UserIcon"] = "UserIcon";
    HeroIcons["UserRemoveIcon"] = "UserRemoveIcon";
    HeroIcons["UsersIcon"] = "UsersIcon";
    HeroIcons["VariableIcon"] = "VariableIcon";
    HeroIcons["VideoCameraIcon"] = "VideoCameraIcon";
    HeroIcons["ViewBoardsIcon"] = "ViewBoardsIcon";
    HeroIcons["ViewGridAddIcon"] = "ViewGridAddIcon";
    HeroIcons["ViewGridIcon"] = "ViewGridIcon";
    HeroIcons["ViewListIcon"] = "ViewListIcon";
    HeroIcons["VolumeOffIcon"] = "VolumeOffIcon";
    HeroIcons["VolumeUpIcon"] = "VolumeUpIcon";
    HeroIcons["WifiIcon"] = "WifiIcon";
    HeroIcons["XCircleIcon"] = "XCircleIcon";
    HeroIcons["XIcon"] = "XIcon";
    HeroIcons["ZoomInIcon"] = "ZoomInIcon";
    HeroIcons["ZoomOutIcon"] = "ZoomOutIcon";
})(HeroIcons || (HeroIcons = {}));
//# sourceMappingURL=heroicons.js.map